<div class="main-container">
    <div class="row content-area">
        <div class="col-12 text-right">
            <button mat-raised-button color="primary" class="save-hra-button upper-btns" (click)="saveHRA()" [disabled]="hasChanged === false">Save</button>
            <button mat-raised-button class="upper-btns" (click)="toTickets()">Cancel</button>
        </div>
        <mat-card class="col-12">
            <mat-card-header>
                <mat-card-title>Mobicint High Risk Authentication</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <mat-accordion>
                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                            <mat-panel-title><p class="h4">High Risk Overview</p></mat-panel-title>
                        </mat-expansion-panel-header>
                        <p>Mobicint High Risk Authentication allows the member to be prompted with additional security
                            questions and information in order to confirm the members identity. There are now two different
                            layers, or "methods" of authentication. Depending on the action that the member is attempting
                            to perform they may be prompted with different types of authentication.</p>

                        <p>For example, when a member logs in they are shown method 1 which may ask them to select an image
                            from a list of images. Then when that member attempts to access Bill Pay, they are shown method 2
                            which might ask them a challenge question.</p>

                        <p>Multi-layered authentication provides increased security from keyloggers, trojans, and phishing
                            attempts. As an example of how this may work to protect your members, if a keylogger discovers
                            method 1 authentication details then they can login as that user, but if they haven't also discovered
                            method 2 authentication details they won't be able to access Bill Pay (or whichever action you define
                            to use method 2). You may think of method 2 as a higher layer of security for your members that
                            will protect them better than a single authentication method would be able to do.</p>
                    </mat-expansion-panel>

                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                            <mat-panel-title><p class="h4">High Risk Authentication Setup</p></mat-panel-title>
                        </mat-expansion-panel-header>
                        <p>To set up High Risk Authentication you may use the form below. Your existing high risk authentication
                            settings have already been imported. Also note that the login action is prefilled to use method 1.
                            This defaults to recommended behavior and currently cannot be changed.</p>

                        <p>It is up to the credit union to do your own evaluation and determine which actions are high
                            risk for its members. Currently only the login action is considered high risk, but you may setup
                            any of the following actions to be high risk and also specify which method of authentication you
                            would like to happen when that action is accessed.</p>

                        <p>After that you will need to define what types of authentication you want to prompt for method 1
                            and method 2. Method 1 has automatically been filled out with your current authentication setup.
                            If you would like to add an additional authentication method for some actions this is where you
                            will define the additional method. If you would like to redefine your method 1, and possibly
                            move parts of method 1 over to method 2, you may do that here as well. Please keep in mind that
                            when you add additional authentication methods you may want to also set a new enrollment period
                            to give your members time to set these new security features. If no enrollment period is set,
                            the users will be forced to enroll the next time they login after the new authentication setup
                            is complete.</p>
                    </mat-expansion-panel>

                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                            <mat-panel-title><p class="h4">High Risk Authentication Options</p></mat-panel-title>
                        </mat-expansion-panel-header>
                        <p>The credit union will be able to select which authentication options to have enabled for
                            method 1 or method 2. Below is a list and brief summary of the currently available authentication
                            options. If you have more questions about these options you may contact PC/WEB support.</p>
                        <ul>
                            <li>Display Image - Display an image that the member has previously selected. This lets the user
                                know that they are communicating with the correct server because it is showing them their correct image.</li>
                            <li>Select Image - Display a list of images for the user to select. This has the benefits of
                                'Display Image' for the member plus benefits of additional authentication for the server.</li>
                            <li>Captcha - Display an obscured image of a word the member has previously entered. This helps
                                prevent bots, or automated programs, from attempting to guess a member's authentication details.</li>
                            <li>Security Word - A text box for the user to enter a security word into. Serves as a secondary password.</li>
                            <li>Display Image - Display an image that the member has previously selected. This lets the user
                                know that they are communicating with the correct server because it is showing them their correct image.</li>
                            <li>Challenge Question - The member will be prompted to answer a question that they have previously
                                provided the answer for. A question will be randomly chosen from the list of questions the member
                                has provided answers for. Optionally at enrollment, the member may enter their own question.</li>
                            <li>Email Authentication - A security code will be sent via e-mail to one of the security contacts
                                the member has on file. This verifies the member based on their email address that an attacker
                                may not have access to.</li>
                        </ul>

                    </mat-expansion-panel>
                </mat-accordion>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="row content-area">
        <mat-card class="col-6">
            <mat-card-header>
                <mat-card-title>Method 1</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div class="row">
                    <div class="col">
                        <h5 class="method-label">Type</h5>
                    </div>
                    <div class="col text-right">
                        <h5 class="method-label">Enabled</h5>
                    </div>
                </div>
                <hr>
                <mat-selection-list class="method1-list" (selectionChange)="openImageSelection(0, $event)">
                    <mat-list-option [class.display-or-select]="type === 'Display Image' || type === 'Select Image'"
                                     *ngFor="let type of typeList" [value]="type" class="type-list-options"
                                     (click)="changeMethod(0, typeList.indexOf(type))">{{type}}</mat-list-option>
                </mat-selection-list>
            </mat-card-content>
        </mat-card>
        <mat-card class="col-6">
            <mat-card-header>
                <mat-card-title>Method 2</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div class="row">
                    <div class="col">
                        <h5 class="method-label">Type</h5>
                    </div>
                    <div class="col text-right">
                        <h5 class="method-label">Enabled</h5>
                    </div>
                </div>
                <hr>
                <mat-selection-list class="method2-list" (selectionChange)="openImageSelection(1, $event)">
                    <mat-list-option [class.display-or-select]="type === 'Display Image' || type === 'Select Image'" *ngFor="let type of typeList" [value]="type" (click)="changeMethod(1, typeList.indexOf(type))">{{type}}</mat-list-option>
                </mat-selection-list>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="row content-area hra-actions">
        <mat-card class="col-12">
            <mat-card-header>
                <mat-card-title>High Risk Action</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>Please select the actions that you would like to configure as high risk, as well as the method of
                    authentication you would like to user for that action.</p>

                <p>Please note that the list of Mobicint actions is all inclusive and some actions may not be applicable to your credit union.</p>

                <p>For #Actions/30 days, if you set it to "Always" it will always decide to prompt when the count test is done.
                    This does not mean it will prompt every time the action is done, by default each action will only be prompted
                    once per session. If you set it to "Never" it won't ever prompt based on this test, but still may prompt based on the amount test.</p>

                <p>For $Amount/30 days, if you leave it blank, this test will be ignored. This test is currently only available for transfers and withdrawals.</p>

                <div class="row column-headers">
                    <h5 class="col-3">Action</h5>
                    <h5 class="col-3">High Risk Method</h5>
                    <h5 class="col-3"># Actions/30 Days</h5>
                    <h5 class="col-3">$ Amount/30 Days</h5>
                </div>
                <hr>
                <div class="row action-list" *ngFor="let action of actionList">
                    <h5 class="col-3">
                        {{action.action}}
                    </h5>
                    <mat-form-field class="col-3" >
                        <mat-select class="method-dropdown" (selectionChange)="fieldChanged()" [(ngModel)]="action.method" [value]="action.method" placeholder="Method">
                            <mat-option value="null"></mat-option>
                            <mat-option value="1">Method 1</mat-option>
                            <mat-option value="2">Method 2</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="col-3" >
                        <mat-select class="frequency-dropdown" (selectionChange)="fieldChanged()" [(ngModel)]="action.perMonth" [value]="action.perMonth" placeholder="Frequency">
                            <mat-option value="null"></mat-option>
                            <mat-option value="true">Always</mat-option>
                            <mat-option value="false">Never</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="col-3" *ngIf="action.action == 'Transfers' || action.action == 'Withdrawals'">
                        <mat-label>$ Amount/30 Days</mat-label>
                        <input type="number" matInput [(ngModel)]="action.amounts">
                    </mat-form-field>
                </div>
                <mat-card-actions class="text-right">
                    <button mat-raised-button color="primary" class="save-hra-button" (click)="saveHRA()" [disabled]="hasChanged === false">Save</button>
                    <button mat-raised-button (click)="toTickets()">Cancel</button>
                </mat-card-actions>
            </mat-card-content>
        </mat-card>
    </div>
</div>
